<template>
  <div class="side-container">
    <h2 class="title">年份导航</h2>
    <ul class="side-content" v-if="sideLists.length > 0">
      <li
        v-for="(item, i) in sideLists"
        :key="item.id"
        ref="sideLi"
        class="side-li"
        :class="{ active: i === index }"
        @click="handleClick(item, i)"
      >
        <div class="left">
          <span class="content">{{ item }}</span>
        </div>
      </li>
      <p class="more" @click="handleMore">更多</p>
      <Spin size="large" fix v-if="spinShow"></Spin>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    sideList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      index: -1,
      curPage: 1,
      sideLists: [],
      spinShow: false,
    };
  },
  created() {
    this.getYearList({
      pageNo: 1,
      pageSize: 5,
    });
  },
  methods: {
    handleClick(item, i) {
      this.index = i;
      let element = this.$refs.sideLi[this.index];
      if (element.classList.contains("active")) {
        element.classList.remove("active");
        this.$emit("requestAll");
      } else {
        element.classList.add("active");
        this.$emit("yearClick", item);
      }
    },
    handleMore() {
      this.getYearList({
        pageNo: ++this.curPage,
        pageSize: 5,
      });
      this.spinShow = true
    },
    async getYearList(data) {
      const resp = await this.$apis.xsjhServe.getYearList(data);
      this.sideLists.push(...resp.yearSet);
      this.spinShow = false
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .ivu-spin-main {
  top: 50% !important;
}
.side-content::-webkit-scrollbar {
  width: 6px;
}
.side-content::-webkit-scrollbar-thumb {
  width: 6px;
  // border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px #A3CBE7;
  background: #A3CBE7;
}
.side-content::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px #fff;
  border-radius: 0;
  // background: rgba(0, 0, 0, 0.1);
}
.side-container {
  width: 100%;
  // box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.13);
  box-sizing: border-box;
  display: inline-block;
  background-color: #ffffff;
  margin-bottom: 9px;
  padding-bottom: 38px;
  .title {
    font-size: 18px;
    font-weight: 400;
    color: #333333;
    margin: 27px 0px 0 30px;
  }
  .side-content {
    margin-top: 13px;
    max-height: 459px;
    overflow: auto;
    .side-li {
      height: 44px;
      line-height: 44px;
      cursor: pointer;
      padding: 0 4px;
      &.active {
        box-shadow: 0px 7px 15px 1px rgba(8, 10, 58, 0.23);
      }
      .left {
        height: 100%;
        margin-left: 30px;
      }
      .content {
        display: inline-block;
        width: 150px;
        font-size: 14px;
        font-weight: 400;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        vertical-align: middle;
        margin-right: 72px;
        color: inherit;
      }
      &:hover {
        background: #3A7AED;
        color: #fff
      }
    }
  }
  .more {
    margin-left: 35px;
    cursor: pointer;
  }
}
</style>
